export default __webpack_public_path__ + "static/media/forvia.8759f54a.png";